export default function OverrideMaxWidth(width, delta) {
    return  (width - delta) +"px !important"
}